/*
 * Damă / Bărbați tabs shared by homepage sections (category rail, bestsellers).
 * Picking a gender in one section switches every other <ps-gender-tabs> on the page
 * and is remembered for the next visit.
 */
if (!customElements.get('ps-gender-tabs')) {
  const STORAGE_KEY = 'ps-gender';
  const EVENT_NAME = 'ps:gender-change';

  const readStored = () => {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  };

  const writeStored = (gender) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, gender);
    } catch (error) {
      // Storage blocked (private mode); the choice still applies on this page.
    }
  };

  class PsGenderTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"][data-gender]'));
      if (this.tabs.length === 0) return;

      this.onGlobalChange = (event) => this.select(event.detail.gender, false);
      document.addEventListener(EVENT_NAME, this.onGlobalChange);

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.gender, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      if (this.hasAttribute('data-lock-gender')) return;

      const stored = readStored();
      if (stored && stored !== this.current) this.select(stored, false);
    }

    disconnectedCallback() {
      if (this.onGlobalChange) document.removeEventListener(EVENT_NAME, this.onGlobalChange);
    }

    get current() {
      const active = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      return active ? active.dataset.gender : null;
    }

    onKeydown(event, index) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const step = event.key === 'ArrowRight' ? 1 : -1;
      const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
      this.select(next.dataset.gender, true);
      next.focus();
    }

    select(gender, broadcast) {
      const target = this.tabs.find((tab) => tab.dataset.gender === gender);
      if (!target) return;

      this.tabs.forEach((tab) => {
        const selected = tab === target;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });

      if (!broadcast) return;
      writeStored(gender);
      document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { gender } }));
    }
  }

  customElements.define('ps-gender-tabs', PsGenderTabs);
}
